import { Injectable, EventEmitter, inject } from '@angular/core';
import { ITagModel, TagModel } from '@fi-shared/models';
import { FiBackendService } from '@fi-shared/fi-backend/fi-backend.service';
import { ILightWeightObjectCollection } from '@fi-shared/models';
import { IFiHttpPromise } from '@fi-shared/to-fi-promise';
import { ContentLanguagesService } from '@fi-app/utilities/fi-services/content-languages.service';
import { IItemsListDataFetchResult, IItemsListParameterBase } from '@fi-shared/fi-items-list/fi-items-list';
import { LoadingService } from '@fi-shared/fi-loading/loading.service';

@Injectable()
export class TagService {
    private tagSaved = new EventEmitter();
    private tagDeleted = new EventEmitter();

    private fiBackend = inject(FiBackendService);
    private contentLanguagesService = inject(ContentLanguagesService);
    private fiLoading = inject(LoadingService);

    GetTag(id: number): Promise<TagModel> {
        const tag = new TagModel();
        const promise = new Promise<TagModel>((resolve, reject) => {
            if (id > 0) {
                this.fiBackend.fetchData<ITagModel>(`Core/Tag/GetTag/${id}`).then((response) => {
                    tag.Initialize(response);
                    this.contentLanguagesService.InitializeContentLanguages(tag, response);
                    resolve(tag);
                }, reject);
            } else {
                this.contentLanguagesService.InitializeContentLanguages(tag);
                resolve(tag);
            }
        });

        return promise;
    }

    SaveTag(tag: TagModel): IFiHttpPromise<number> {
        //Creating a new object because it looks bad in the GUI otherwise.
        const tagApiModel = JSON.parse(JSON.stringify(tag));
        const promise = this.fiBackend.fetchDataPost<number>('Core/Tag/SaveTag', tagApiModel);
        promise.then(() => this.tagSaved.emit());
        return promise;
    }

    DeleteTags(tagIdsToDelete: number[]): Promise<void> {
        const promise = this.fiBackend.fetchDataPost<void>('Core/Tag/DeleteTags', tagIdsToDelete);
        promise.then(() => this.tagDeleted.emit());
        return this.fiLoading.trackPromise(promise);
    }

    GetLightWeightObjectsForLocalSearch(tagParameterApiModel): IFiHttpPromise<ILightWeightObjectCollection> {
        return this.fiBackend.fetchDataPost<ILightWeightObjectCollection>(
            'Core/Tag/GetLightWeightObjectsForLocalSearch',
            tagParameterApiModel,
        );
    }

    getTagsListData(parameter: IItemsListParameterBase): Promise<IItemsListDataFetchResult<ITagModel>> {
        return this.fiBackend.fetchDataPost<IItemsListDataFetchResult<ITagModel>>(
            'Core/Tag/GetTagsListData',
            parameter,
        );
    }

    GetTags(tagParameterApiModel: IItemsListParameterBase): IFiHttpPromise<TagModel[]> {
        return this.fiBackend.fetchDataPost<TagModel[]>('Core/Tag/GetTags', tagParameterApiModel);
    }

    GetTagsCount(tagParameterApiModel: IItemsListParameterBase): IFiHttpPromise<number> {
        return this.fiBackend.fetchDataPost('Core/Tag/GetTagsCount', tagParameterApiModel);
    }

    getAllLightWeightTags() {
        return this.fiBackend.fetchData('Core/Tag/GetAllLightWeightTags');
    }

    UntagItems(tagId) {
        return this.fiBackend.fetchDataPost<void>(`Core/Tag/UntagItems/${tagId}`);
    }

    GetModuleTagsByUserAccessRights(moduleType) {
        return this.fiBackend.fetchData<TagModel[]>('Core/Tag/GetModuleTagsByUserAccessRights/' + moduleType);
    }
}
